import { useState } from "react";
import { Box } from "@mui/material";
import PatientDatas from "src/modules/medcard/patient-datas";
import { usePatientCare } from "./hooks/usePatientCare";
import PatientCareHeader from "./PatientCareHeader";
import PatientCareGrids from "./PatientCareGrids";
import PatientCareDialogs from "./PatientCareDialogs";

function PatientCareDefinition() {
  const [patientInfo, setPatientInfo] = useState<any>(null);

  const {
    date, patientId, handleDateChange,
    treeRows, isDataLoading,
    selectedChildDetails, setSelectedChildDetails,
    selectedPlanPeriods, setSelectedPlanPeriods,
    selectedIds, setSelectedIds,
    lastSelectedTreeId, setLastSelectedTreeId,
    lastSelectedInterventionId, setLastSelectedInterventionId,
    dialogOpen, setDialogOpen,
    isEditDialogOpen, setEditDialogOpen, currentEditRow, setCurrentEditRow,
    isNurseEditDialogOpen, setNurseEditDialogOpen, nurseCurrentEditRow, setNurseCurrentEditRow,
    isPlanEditDialogOpen, setPlanEditDialogOpen, planCurrentEditRow, setPlanCurrentEditRow,
    dialogTreeOpen, setDialogTreeOpen, dialogTreeNewOpen, setDialogTreeNewOpen,
    selectedTreeId, 
    setSelectedRowForPeriodPlanning,
    selectedRowDataForNewPeriod, setSelectedRowDataForNewPeriod,
    deleteState, setDeleteState,
    secondGridDeleteState, setSecondGridDeleteState,
    isDeleting, isSecondGridDeleting,
    handleDeleteGuide, handleDeletePlan, handleDeleteConfirm,
    handleDeleteIntervention, handleDeletePlanning, handleSecondGridDeleteConfirm,
    handleCopyGuide, handlePasteGuide, copiedGuideData,
    handleTreeSelect,
    setRefreshKey,
    handleSaveEdit, handleSaveNurseEdit, handleSavePlanEdit,
    handleProcessAction
  } = usePatientCare();

  return (
    <Box sx={{ padding: "20px", width: "100%" }}>
      <PatientDatas 
        isCreateMedCard={true} 
        isOpenMedCard={true} 
        patientDataOut={(data) => setPatientInfo(data.data)} 
      />

      <PatientCareHeader 
        date={date} 
        onAddClick={() => setDialogOpen(true)} 
        onDateChange={handleDateChange} 
      />

      <PatientCareGrids 
        treeRows={treeRows}
        isDataLoading={isDataLoading}
        selectedChildDetails={selectedChildDetails}
        selectedPlanPeriods={selectedPlanPeriods}
        selectedIds={selectedIds}
        date={date}
        copiedGuideData={copiedGuideData}
        onSelectionChange={setSelectedPlanPeriods}
        onChildSelectionChange={setSelectedChildDetails}
        onDeleteGuide={handleDeleteGuide}
        onDeletePlan={handleDeletePlan}
        onCopyGuide={handleCopyGuide}
        onPasteGuide={handlePasteGuide}
        onEditGuidePlan={(row) => { setCurrentEditRow(row); setEditDialogOpen(true); }}
        onEditIntervention={(row) => { setNurseCurrentEditRow(row); setNurseEditDialogOpen(true); }}
        onEditPlanning={(row) => { setPlanCurrentEditRow(row); setPlanEditDialogOpen(true); }}
        onTreeSelect={handleTreeSelect}
        onHandleProcessAction={handleProcessAction}
        onDeleteIntervention={handleDeleteIntervention}
        onDeletePlanning={handleDeletePlanning}
        setSelectedRowForPeriodPlanning={setSelectedRowForPeriodPlanning}
        setSelectedRowDataForNewPeriod={setSelectedRowDataForNewPeriod}
        lastSelectedTreeId={lastSelectedTreeId}
        setLastSelectedTreeId={setLastSelectedTreeId}
        lastSelectedInterventionId={lastSelectedInterventionId}
        setLastSelectedInterventionId={setLastSelectedInterventionId}
        setSelectedIds={setSelectedIds}
      />

      <PatientCareDialogs 
        patientId={patientId}
        patientInfo={patientInfo}
        dialogOpen={dialogOpen}
        onCloseDialog={() => { setDialogOpen(false); setRefreshKey(prev => prev + 1); }}
        isEditDialogOpen={isEditDialogOpen}
        currentEditRow={currentEditRow}
        onCloseDialogEdit={() => { setEditDialogOpen(false); setCurrentEditRow(null); }}
        onSaveEdit={handleSaveEdit}
        isNurseEditDialogOpen={isNurseEditDialogOpen}
        nurseCurrentEditRow={nurseCurrentEditRow}
        onCloseDialogNurseEdit={() => { setNurseEditDialogOpen(false); setNurseCurrentEditRow(null); }}
        onSaveNurseEdit={handleSaveNurseEdit}
        isPlanEditDialogOpen={isPlanEditDialogOpen}
        planCurrentEditRow={planCurrentEditRow}
        onCloseDialogPlanEdit={() => { setPlanEditDialogOpen(false); setPlanCurrentEditRow(null); }}
        onSavePlanEdit={handleSavePlanEdit}
        dialogTreeOpen={dialogTreeOpen}
        setDialogTreeOpen={setDialogTreeOpen}
        selectedTreeId={selectedTreeId}
        dialogTreeNewOpen={dialogTreeNewOpen}
        onCloseTreeNewDialog={() => setDialogTreeNewOpen(false)}
        selectedRowDataForNewPeriod={selectedRowDataForNewPeriod}
        setDialogTreeNewOpen={setDialogTreeNewOpen}
        onSuccessNewPlan={() => {
          setRefreshKey(prev => prev + 1);
          setSelectedChildDetails([]);
          setSelectedPlanPeriods([]);
          setSelectedIds([]);
        }}
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        onDeleteConfirm={handleDeleteConfirm}
        isDeleting={isDeleting}
        secondGridDeleteState={secondGridDeleteState}
        setSecondGridDeleteState={setSecondGridDeleteState}
        onSecondGridDeleteConfirm={handleSecondGridDeleteConfirm}
        isSecondGridDeleting={isSecondGridDeleting}
      />
    </Box>
  );
}

export default PatientCareDefinition;
